/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaIconCopyFilled from 'DesignSystem/Svgs/TysiaIconCopyFilled/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/TopBar/Order/Content/Content/OrderStatuses/Content/OrderStatus/OrderId/Content"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let orderStatusOrderIdValueData = fromData.useDataValue({ viewPath,
context: 'order_status',
path: 'order_id',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral400}
 size="small"
 text="Order ID"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral900}
 size="small"
 data="order_status.order_id"
 text={orderStatusOrderIdValueData}
/>
<button
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 title="Copy order id"
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaIconCopyFilled
  viewPath={`${viewPath}/TysiaIconCopyFilled`}
 fill2={dtColorsNeutral400}
 height={12}
 width={12}
/>
</button>
</div>
{children}
</React.Fragment>)
}